import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SvgIconComponent } from 'angular-svg-icon';
import { CdkMenu, CdkMenuItemRadio, CdkMenuTrigger } from '@angular/cdk/menu';
import { ChatRoom } from '@core/interfaces/chat.interface';

@Component({
  selector: 'app-chat-room',
  imports: [SvgIconComponent, CdkMenuTrigger, CdkMenu, CdkMenuItemRadio],
  templateUrl: './chat-room.component.html',
  styleUrl: './chat-room.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatRoomComponent {
  rooms = input.required<ChatRoom[]>();
  currentRoom = input.required<ChatRoom>();
  count = input.required<number>();

  changeCurrentRoom = output<ChatRoom['id']>();
}
